"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirections = void 0;
var SortDirections;
(function (SortDirections) {
    SortDirections["asc"] = "asc";
    SortDirections["desc"] = "desc";
})(SortDirections = exports.SortDirections || (exports.SortDirections = {}));
